import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Form, Label, Dropdown, Radio } from 'semantic-ui-react';

import { validateExp } from '../../utils/validation';

class InputField extends Component {
  state = {
    error: false,
  }

  allowOnlyNumbers (e) {
    const keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);
    // Allow: backspace, delete, tab, escape, enter and .
    if (_.findIndex([46, 8, 9, 27, 13, 110, 190], e.keyCode) !== -1 ||
      // Allow: Ctrl+A,Ctrl+C,Ctrl+V, Command+A
      ((keyID === 65 || keyID === 86 || keyID === 67 || keyID === 88) && (e.ctrlKey === true || e.metaKey === true)) ||
      // Allow: home, end, left, right, down, up
      (keyID >= 35 && keyID <= 40)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (keyID < 48 || keyID > 57)) && (keyID < 96 || keyID > 105)) {
      e.preventDefault();
    }
  }

  handleInpuChange (e) {
    const { validation, maxLengh } = this.props;
    const { value } = e.target;
    let error = false;
    if (validation && validation.justLetters) {
      error = value && !validateExp({ type: 'justLetters', value });
    } else if (validation && validation.justNumbers) {
      error = value && !validateExp({ type: 'justNumbers', value });
    }
    this.setState({ error });
    if (maxLengh && value.length <= maxLengh) this.props.onChange(e, error);
    if (!maxLengh) this.props.onChange(e, error);
  }

  handleInputBlur (e, required) {
    if (required) {
      if (e.target.value === '') {
        this.setState({ error: true });
      }
    }
  }

  render () {
    const {
      required,
      label,
      errorMessage,
      placeholder,
      inputType,
      value,
      name,
      onChange,
      error,
      customClass,
      options,
      readOnly,
    } = this.props;
    if (inputType === 'select') {
      return (
        <Form.Field
          required={ required }
          onChange={ onChange }
          error={ error }
          className={ customClass }
        >
          <label>{ label }</label>
          <Dropdown
            selection
            search
            compact
            options={ options }
            value={ value }
            name={ name }
            onChange={ (e, { value, name }) => onChange({ value, name }) }
          />
          <Label basic pointing>{ errorMessage }</Label>
        </Form.Field>
      );
    }
    if (inputType === 'radio') {
      return (
        <Form.Field
          required={ required }
          error={ error }
          className={ customClass }
        >
          <Radio
            label={ label }
            name={ name }
            value={ value }
            onChange={ onChange }
          />
        </Form.Field>
      );
    }
    return (
      <Form.Field
        required={ required }
        error={ this.state.error }
        className={ customClass }
      >
        <label>{ label }</label>
        <input
          name={ name }
          type={ inputType }
          value={ value }
          onChange={ e => this.handleInpuChange(e) }
          onBlur={ e => this.handleInputBlur(e, required) }
          placeholder={ placeholder }
          onKeyPress={ inputType === 'number' ? this.allowOnlyNumbers : () => {} }
          readOnly={ readOnly }
        />
        <Label basic pointing>{ errorMessage }</Label>
      </Form.Field>
    );
  }
}

InputField.propTypes = {
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  inputType: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  customClass: PropTypes.string,
  options: PropTypes.array,
  validation: PropTypes.shape({
    justLetters: PropTypes.bool,
    justNumbers: PropTypes.bool,
    confirmEmail: PropTypes.string,
  }),
};

export default InputField;
